import React, {useCallback, useContext, useMemo} from 'react';
import ThemeContext from '../context/ThemeContext';
import {useVoiceAction} from './VoiceControlSurfaceContext';

const VoiceThemeActions: React.FC = () => {
    const {theme, setTheme, toggleTheme} = useContext(ThemeContext);

    useVoiceAction(
        useMemo(
            () => ({
                id: 'set_theme',
                label: 'Set Theme',
                description:
                    'Switch the application theme to light mode, dark mode, or toggle between them.',
                parameters: {
                    type: 'object',
                    properties: {
                        theme: {
                            type: 'string',
                            enum: ['light', 'dark', 'toggle'],
                            description:
                                'Use light for light mode, dark for dark mode, or toggle to switch from the current theme.'
                        }
                    },
                    required: ['theme'],
                    additionalProperties: false
                }
            }),
            []
        ),
        useCallback(
            args => {
                const requestedTheme =
                    typeof args.theme === 'string'
                        ? args.theme.toLowerCase()
                        : '';

                if (requestedTheme === 'toggle') {
                    const nextTheme = theme === 'light' ? 'dark' : 'light';
                    toggleTheme();
                    return {
                        message: `Switched to ${nextTheme} mode.`,
                        data: {theme: nextTheme}
                    };
                }

                if (requestedTheme === 'light' || requestedTheme === 'dark') {
                    setTheme(requestedTheme);
                    return {
                        message: `Switched to ${requestedTheme} mode.`,
                        data: {theme: requestedTheme}
                    };
                }

                return {
                    message: 'Theme must be light, dark, or toggle.',
                    data: {theme}
                };
            },
            [setTheme, theme, toggleTheme]
        ),
        {global: true}
    );

    return null;
};

export default VoiceThemeActions;
